import { render, staticRenderFns } from "./Beranda.vue?vue&type=template&id=22e2663f&"
import script from "./Beranda.vue?vue&type=script&lang=js&"
export * from "./Beranda.vue?vue&type=script&lang=js&"
import style0 from "./Beranda.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Beranda.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports